import { Route, Switch } from 'wouter';
import { AdminNav } from './AdminNav';
import JobPostingsAdmin from './pages/JobPostings/JobPostingsAdmin';
import CommunityAnnouncementsAdmin from './pages/community-announcements/CommunityAnnouncementsAdmin';
import CommunityWinsAdmin from './pages/community-wins/CommunityWinsAdmin';
import EventsAdmin from './pages/events/EventsAdmin';
import FundingOpportunitiesAdmin from './pages/funding-opportunities/FundingOpportunitiesAdmin';
import { ProjectReview } from './pages/projects/ProjectReview';
import { ProjectsAdmin } from './pages/projects/ProjectsAdmin';
import { IntroductionsAdmin } from './pages/introductions/IntroductionsAdmin';
import { OrganizationsAdmin } from './pages/organizations/OrganizationsAdmin';
import { OrganizationVetting } from './pages/organizations/OrganizationVetting';
import { MeetingsAdmin } from './pages/meetings/MeetingsAdmin';
import { CommunityMeetingDetail } from './pages/meetings/CommunityMeetingDetail';
import { EIRMeetingDetail } from './pages/meetings/EIRMeetingDetail';

export const Admin = () => {
  return (
    <div>
      <AdminNav />
      <div className='p-8'>
        <Switch>
          <Route path='/job-postings'>
            <JobPostingsAdmin />
          </Route>
          <Route path='/community-wins'>
            <CommunityWinsAdmin />
          </Route>
          <Route path='/community-announcements'>
            <CommunityAnnouncementsAdmin />
          </Route>
          <Route path='/events'>
            <EventsAdmin />
          </Route>
          <Route path='/funding-opportunities'>
            <FundingOpportunitiesAdmin />
          </Route>
          <Route path='/projects'>
            <ProjectsAdmin />
          </Route>
          <Route path='/projects/review/:id'>
            <ProjectReview />
          </Route>
          <Route path='/introductions'>
            <IntroductionsAdmin />
          </Route>
          <Route path='/organizations'>
            <OrganizationsAdmin />
          </Route>
          <Route path='/organizations/vetting/:organizationId'>
            <OrganizationVetting />
          </Route>
          <Route path='/meetings/community/:id'>
            <CommunityMeetingDetail />
          </Route>
          <Route path='/meetings/eir/:id'>
            <EIRMeetingDetail />
          </Route>
          <Route path='/meetings'>
            <MeetingsAdmin />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default Admin;
